import { Navigate } from 'react-router-dom'
import { useAuth } from '../shared/hooks/useAuth'
import type { UserRole } from '../shared/lib/supabase'

interface RoleBasedRouteProps {
  children: React.ReactNode
  allowedRoles: UserRole[]
  redirectTo?: string
}

/**
 * Route wrapper that restricts access based on user role.
 * If user's role is not in allowedRoles, redirects to specified path.
 */
export function RoleBasedRoute({
  children,
  allowedRoles,
  redirectTo = '/unauthorized'
}: RoleBasedRouteProps) {
  const { role, loading } = useAuth()
  if (loading) return <div role="status" className="p-6">Checking access…</div>
  if (!role) return <Navigate to={redirectTo} replace />

  // If role is present but not allowed, redirect
  if (!allowedRoles.includes(role)) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
